exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.columnlistBox[data-v-1827d012] {\n    margin-top: 0;\n    padding: 0 20px;\n    background-color: #fff;\n}\n.columnlistBox .column_li[data-v-1827d012] {\n      width: 100%;\n      height: auto;\n      border-bottom: 1px solid #eee;\n}\n}\n", ""]);

